import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const EventTitle = styled.span<{ shrink: boolean }>`
  bottom: ${172 * Screen.widthRatio}px;
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${50 * Screen.widthRatio}px;
  left: ${283 * Screen.widthRatio}px;
  line-height: ${64 * Screen.widthRatio}px;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${(props) => (props.shrink ? 622 : 1182) * Screen.widthRatio}px;
`;

export default EventTitle;
